import { render, staticRenderFns } from "./InvoicesPageV3.vue?vue&type=template&id=3e6edfd8&scoped=true"
import script from "./InvoicesPageV3.vue?vue&type=script&lang=js"
export * from "./InvoicesPageV3.vue?vue&type=script&lang=js"
import style0 from "./InvoicesPageV3.vue?vue&type=style&index=0&id=3e6edfd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6edfd8",
  null
  
)

export default component.exports